<template>
  <Container class="bg-[#E4F4FC] py-[40px]">
    <!-- Title + Description -->
    <div class="flex flex-col gap-3 text-left  mb-12 px-8 md:px-0">
      <h2
          class="text-center md:text-left"
        style="
          font-family: 'Outfit', sans-serif;
          font-size: 40px;
          font-weight: 700;
          line-height: 1.2;
          color: #3B5EA6;
        "
      >
        Reaching Classrooms Across the Country
      </h2>
      <p
          class="text-center md:text-left"
        style="
          font-family: 'Outfit', sans-serif;
          font-size: 24px;
          font-weight: 400;
          line-height: 1.5;
          color: #1a1a1a;
        "
      >
        To date, we've launched 9 customized state hubs to tailor resources to local needs
      </p>
    </div>

    <!-- States Grid -->
    <div v-if="loading" class="text-gray-500 text-base py-8">Loading...</div>
    <div v-else-if="error" class="text-red-500 text-base py-8">{{ error }}</div>

    <div v-else class="grid grid-cols-3 gap-x-2 gap-y-3 md:gap-x-8 md:gap-y-6">
      <div
        v-for="state in states"
        :key="state.id"
        class="state-card flex flex-col items-center gap-1 px-1 py-2 md:flex-row md:gap-4 md:px-4 md:py-3 rounded-xl cursor-pointer transition-all duration-200"
      >
        <!-- State logo -->
        <div class="flex-shrink-0 w-8 h-8 md:w-16 md:h-16 flex items-center justify-center">
          <img
            v-if="state.logo_dark_url"
            :src="state.logo_dark_url"
            :alt="state.name"
            class="w-full h-full object-contain"
          />
        </div>

        <!-- State name -->
        <span
          class="text-center md:text-left"
          style="
            font-family: 'Outfit', sans-serif;
            font-weight: 600;
            color: #000;
            font-size: clamp(10px, 2vw, 24px);
          "
        >
          {{ state.name }}
        </span>
      </div>
    </div>
  </Container>
</template>

<script>
import Container from "../../../../Layouts/Container.vue";
import axios from "axios";

export default {
  components: { Container },
  data() {
    return {
      isMobile: typeof window !== 'undefined' ? window.innerWidth < 768 : (this.$page?.props?.isMobileUA ?? false),
      states: [],
      loading: false,
      error: null,
    };
  },
  props: {},
  mounted() {
    this.fetchStates();
  },
  methods: {
    async fetchStates() {
      this.loading = true;
      this.error = null;
      try {
        const { data } = await axios.get("/api/states");
        this.states = data.states;
      } catch (e) {
        this.error = "Failed to load states.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.state-card {
  background-color: transparent;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
}

.state-card:hover {
  background-color: #ffffff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.10), 0 1px 4px rgba(0, 0, 0, 0.06);
}
</style>
